import type { Event } from "@circle-react/types";
import { ScheduledEmailSection } from "./ScheduledEmailSection";
import { ScheduledEmailProvider } from "./useScheduledEmailContext";

interface EmailProps {
  event: Event;
}

export const Email = ({ event }: EmailProps) => (
  <ScheduledEmailProvider event={event}>
    <ScheduledEmailSection event={event} />
  </ScheduledEmailProvider>
);
